import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { PREPAY_PHONES_URL } from '../eir-prepay-constants/ApplicationConstants';
import CloseIcon from '@material-ui/icons/Close';
import Constants from '../../Constants';
import {
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    IconButton,
} from '@material-ui/core';
const useStyles = makeStyles({
    eirDialog: {
        padding: '8px 0px 40px',
        '@media (max-width: 767px)': {
            fontSize: '18px',
            padding: '0px 0px 18px',
        },
    },

    dialogPaper: {
        overflowY: 'visible !important',
        maxWidth: '700px',
    },

    dialogTitle: {
        position: 'relative',
    },
    closeButton: {
        position: 'absolute',
        right: '-15px',
        top: '-15px',
        fontSize: '18px',
        color: '#892ba0',
        boxShadow: '0px 0px 10px #0000002B',
        opacity: 1,
        outline: 'none',
        background: '#fff',
        '&:focus,&:hover': {
            background: '#fff',
            outline: 'none',
        },
    },
    notification: {
        color: '#323435',
        fontSize: '20px',
        textAlign: 'center',
        padding: '18px 56px 0px',
        fontFamily: ' eir-medium !important',
        '@media (max-width: 767px)': {
            fontSize: '18px',
            padding: '0px',
        },
    },
    pupleBtn: {
        borderRadius: '2rem',
        fontSize: 18,
        textTransform: 'initial',
        padding: '8px 45px',
        border: '1px solid '+Constants.siteTheme.primaryTheme,
        background: Constants.siteTheme.primaryTheme,
        color: '#fff',
        '@media (min-width:280px) and (max-width: 320px)': {
            fontSize: 12,
            padding: '6px 22px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            padding: '8px 30px',
            fontSize: 16,
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            fontSize: 16,
        },
        '&:focus,&:hover': {
            outline: 'none',
            background: Constants.siteTheme.primaryTheme,
            color: '#fff',
        },
    },
    eirDialogContent: {
        padding: '0px 110px',
        '@media (max-width: 767px)': {
            padding: '8px 24px',
        },
    },
    button: { outline: 'none' },
    cancelBtn: {
        borderRadius: '2rem',
        fontSize: 18,
        textTransform: 'initial',
        padding: '8px 48px',
        border: '1px solid #892ba0',
        background: '#fff',
        color: '#892ba0',
        outline: 'none',
        marginRight: '10px',
        '@media (min-width:280px) and (max-width: 320px)': {
            fontSize: 12,
            padding: '6px 24px',
        },
        '@media (min-width:321px) and (max-width: 767px)': {
            padding: '8px 32px',
            fontSize: 16,
        },
        '@media (min-width:768px) and (max-width: 1024px)': {
            padding: '8px 48px',
            fontSize: 16,
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },
});
// function to display a modal when provider is meteor and account type is prepay
export const EirPrepayToPrepayPort= props => {
    const [open, setOpen] = useState(true);
    const classes = useStyles();
    const handleClose = () => {
        setOpen(false);
        props.handleModalOpenStatus(false);
    };
    const handleConfirm = async () => {
        window.location.href = PREPAY_PHONES_URL;
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                PaperProps={{ className: classes.dialogPaper }}
                open={open}
                onClose={handleClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-port-description'
                className={classes.eirDialogContainer}>
                <DialogTitle id='alert-dialog-title' className={classes.dialogTitle}>
                </DialogTitle>
                <IconButton
                    aria-label='close'
                    className={classes.closeButton}
                    onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <DialogContent className={classes.eirDialogContent}>
                    <DialogContentText
                        id='alert-dialog-port-description'
                        className={classes.notification}>
                        <h2 class='h2-title text-center'>Good News!</h2>
                        As you are already an eir prepay customer, you don't need 
                        a new SIM. To purchase a new phone, please click continue.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid item xs={12} sm={12} md={12} align='center' className={classes.eirDialog}>
                        <Button className={classes.cancelBtn} onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className={classes.pupleBtn} onClick={handleConfirm}>
                            Continue
                        </Button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    );
};
